import IConfigEndpoints from "./framework/IConfigEndpoints";
import IAppConfig from "models/IAppConfig";
import EndpointsBaseClass from "apiConsumers/EndpointsBaseClass";

export default class ConfigEndpoints extends EndpointsBaseClass implements IConfigEndpoints {
    public async getConfig(): Promise<IAppConfig> {
        const cdnEndpoint = await this.getCDNEndpoint();

        const response = await this.makeGetRequest(`${cdnEndpoint}/config.json`);

        return response as IAppConfig;
    }

    private async getCDNEndpoint(): Promise<string> {
        let url = `/config`;

        const response = await this.makeGetRequest(url);

        return response.cdnEnpoint as string;
    }
}
